import React, { FC, ReactNode, useState, useRef } from 'react';

//import events from './events';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'moment/locale/en-gb';

import ModalEvent from './ModalEvent';
import SeanceCell from './SeanceCell';
import ModalDelete from './ModalDelete';
import EventForm from 'src/screens/General/screens/Cases/screens/CaseCalendarScreen/components/EventForm';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { ICase } from '../../types/case';
import { Paginated } from '../../services/api-handlers/pagination';
import { ISeance } from '../../types/seance';

import classNames from 'classnames';
import styles from './assets/calendars.scss';
import moment from 'moment';
import { changeToZeroZoneDate, changeToZeroMomentNoFormat } from 'src/helpers/timeHelpers';
import user from '../../services/user-auth';
import UserRole from '../../enumerables/user-role';
//moment_timezone.tz.setDefault('America/Danmarkshavn');
const localizer = momentLocalizer(moment);

interface Props {
    events?: [];
    setEvent: (it: AnyObject) => void;
    caseEnt: ICase | null;
    existData?: any;
    setExistData?: any;
    month?: { monthEnd: string; monthStart: string };
    nowDate: Date | null;
    seanceForm?: any;
    change?: boolean;
    setDate?: (date: any) => void;
    seances: Paginated<ISeance>;
}

const statusListColors: { [key: number]: string } = {
    1: 'upcomingStCell',
    2: 'inProgressStCell', //In progress
    3: 'unconfirmStCell',
    4: 'confirmStCell',
    5: 'cancelStCell',
    6: 'billedStCell',
    7: 'paidStCell',
    8: 'missedBilledStCell',
};

const CalendarComponent: FC<Props> = (props: Props) => {
    const calendarProps: any = useRef(null);

    const [modalData, setModalData] = useState<{ open: boolean; RenderData: ReactNode }>({
        open: false,
        RenderData: <div></div>,
    });
    const events: {
        title: string;
        occasion: string;
        student: string;
        name: string;
        provider: string;
        provId: string;
        canEditSession: string;
        hasPaid: any;
        allDay: false;
        start: any;
        status: number;
        isWeekly: boolean;
        end: any;
        eventColor: string;
        id: number;
    }[] = [];
    const [deleteModal, setDeleteModal] = useState<boolean | number | string>(false);

    const valueProvider: string[] = [];
    //const valueStudent = `${props.caseEnt?.student?.id}`;
    let client: { [key: string]: number } = { studentId: props.caseEnt?.student?.id ? +props.caseEnt?.student?.id : 1 };
    if (props.caseEnt?.district) {
        client = { districtId: props.caseEnt?.district?.id ? +props.caseEnt?.district.id : 1 };
    } else if (props.caseEnt?.vendor) {
        client = { vendorId: props.caseEnt?.vendor?.id ? +props.caseEnt?.vendor.id : 1 };
    }
    //  useEffect(() => {  }, []);
    props.caseEnt?.occasionProviders.forEach((itP: any, k: number) => {
        valueProvider.push(itP.provider?.id);
    });
    // eslint-disable-next-line

    const handleSelect = ({ start, end }: { start: string; end: string }) => {
        if (!props.change) {
            return false;
        }

        const startTime = new Date(start);
        const endTime = new Date(end);
        startTime.setHours(20);

        //const dateObj = changeToZeroZoneDate(start);
        //const dateTime = startTime.setHours(20);
        const startDate = changeToZeroZoneDate(`${props?.caseEnt?.caseNumberValidityFrom}`);
        //startDate.setHours(20);

        if (
            startTime.getTime() < startDate.getTime() ||
            endTime.getTime() > changeToZeroZoneDate(`${props?.caseEnt?.caseNumberValidityTo}`).getTime()
        ) {
            return false;
        }

        if (end === start) {
            const today = new Date(start);
            start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7).toString();
            end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21).toString();
        }
        const caseDropDown = {};
        /*   if (props.caseEnt?.id) {
            caseDropDown = { caseDropDown: { value: props.caseEnt?.id, label: props.caseEnt?.id } };
        }*/

        const SeanceForm: any = props.seanceForm ? (
            <props.seanceForm
                changeAction={props.change ? props.change : false}
                setData={setModalData}
                month={props.month}
                initialValues={{
                    occasion: props.caseEnt?.id,
                    ...caseDropDown,
                    providerId: valueProvider,
                    seanceDate: moment(start).toDate(),
                    startTime: start,
                    endTime: end,
                    ...client,
                }}
            />
        ) : (
            <EventForm
                changeAction={props.change ? props.change : false}
                setData={setModalData}
                existData={props.existData}
                setExistData={props.setExistData}
                initialValues={{
                    occasion: props.caseEnt?.id,
                    providerId: valueProvider,
                    seanceDate: moment(start).toDate(),
                    startTime: start,
                    endTime: end,
                    ...client,
                }}
            />
        );
        setModalData({
            open: true,
            RenderData: SeanceForm,
        });
    };

    props.seances.list.forEach((it: any) => {
        if (it.status === 5) {
            return false;
        }

        const start = changeToZeroZoneDate(it.startTime.replace(/ /g, 'T'));
        const endTm = changeToZeroZoneDate(it.endTime.replace(/ /g, 'T'));
        let name = '';
        if (it.occasion?.caseType === 3) {
            name = it.district ? `${it.district.name}` : 'unknown';
        } else if (it.occasion?.caseType === 4) {
            name = it.vendor ? `${it.vendor.name}` : 'unknown';
        } else {
            name = it.student ? `${it.student.firstName} ${it.student.lastName}` : 'unknown';
        }

        events.push({
            title: `Event ${it.id}`,
            allDay: false,
            name,
            status: it.status,
            isWeekly: it.isWeekly,
            eventColor: statusListColors[it.status] ? statusListColors[it.status] : '',
            occasion: `${it.occasion?.id}`,
            student: it.student ? `${it.student?.firstName} ${it.student?.lastName}` : '',
            provider: `${it.provider?.fullName}`,
            provId: `${it.provider?.id}`,
            canEditSession: `${it.canEditSession}`,
            hasPaid: `${it.hasPaid === true || it.hasPaid === 'true'}`,
            start: start,
            end: endTm,
            id: it.id,
        });
    });

    const customSlotPropGetter = (date: any) => {
        if (date.getDate() === 7 || date.getDate() === 15)
            return {
                className: 'special-day',
            };
        else return {};
    };

    const today = new Date();

    return (
        <div className={'calendarComponent'} style={{ height: 1200 }}>
            <Calendar
                ref={calendarProps}
                min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                selectable
                localizer={localizer}
                events={events}
                defaultView={user.getRoles().includes(UserRole.ROLE_ADMIN) ? 'month' : 'day'}
                timeslots={12}
                onNavigate={(date) => {
                    if (props?.setDate) {
                        props.setDate(changeToZeroMomentNoFormat(`${date}`));
                    }
                }}
                step={5}
                date={changeToZeroZoneDate(`${props.nowDate}`)}
                scrollToTime={new Date(1970, 1, 1, 6)}
                startAccessor="start"
                components={{
                    event: (event) => <SeanceCell {...event} deleteCell={(id) => setDeleteModal(id)} />,
                    eventWrapper: (props: any) => {
                        const { children, event } = props;

                        const types: any = {
                            month: 'type-month',
                            date: 'type-date',
                            week: 'type-week',
                        };

                        return (
                            <div
                                className={classNames(
                                    `${
                                        props?.type === 'time'
                                            ? 'eventWrapperCalendar'
                                            : ' eventWrapperCalendar eventWrapperCalendarDate'
                                    } ${styles.eventWrapper} ${event?.eventColor} ${
                                        types[calendarProps?.current?.props?.view]
                                            ? types[calendarProps.current.props.view]
                                            : 'type-date'
                                    }`,
                                )}
                            >
                                {children}
                            </div>
                        );
                    },
                    eventContainerWrapper: (props: any) => {
                        return <div className={'sssss'}>{props.children}</div>;
                    },
                }}
                onSelectEvent={(itEvent) => {
                    //event.title
                    const { start, end, id, occasion }: any = itEvent;
                    let caseDropDown = {};
                    if (occasion) {
                        caseDropDown = { caseDropDown: { value: occasion, label: occasion } };
                    }

                    const SeanceForm: any = props.seanceForm ? (
                        <props.seanceForm
                            setData={setModalData}
                            month={props.month}
                            deleteAction={() => setDeleteModal(id)}
                            changeAction={props.change ? props.change : false}
                            initialValues={{
                                isWeekly: itEvent.isWeekly,
                                status: itEvent.status,
                                provider: itEvent.provider,
                                provId: itEvent.provId,
                                canEditSession: itEvent.canEditSession,
                                hasPaid: itEvent.hasPaid == true || itEvent.hasPaid == 'true',
                                seanceDate: moment(start).toDate(),
                                startTime: moment(start).toDate(),
                                endTime: moment(end).toDate(),
                                occasion: props.caseEnt?.id,
                                ...caseDropDown,
                                providerId: valueProvider,
                                id: id,
                                ...client,
                            }}
                        />
                    ) : (
                        <EventForm
                            existData={props.existData}
                            setExistData={props.setExistData}
                            setData={setModalData}
                            changeAction={props.change ? props.change : false}
                            initialValues={{
                                isWeekly: itEvent.isWeekly,
                                status: itEvent.status,
                                provider: itEvent.provider,
                                provId: itEvent.provId,
                                canEditSession: itEvent.canEditSession,
                                hasPaid: itEvent.hasPaid == true || itEvent.hasPaid == 'true',
                                seanceDate: moment(start).toDate(),
                                startTime: moment(start).toDate(),
                                endTime: moment(end).toDate(),
                                occasion: props.caseEnt?.id,
                                providerId: valueProvider,
                                id: id,
                                ...client,
                            }}
                        />
                    );
                    setModalData({
                        open: true,
                        RenderData: SeanceForm,
                    });
                }}
                slotPropGetter={customSlotPropGetter}
                dayPropGetter={(date: Date) => {
                    const dateObj: any = changeToZeroZoneDate(`${date}`);
                    dateObj.setHours(24, 0, 0, 0);
                    const startDate = new Date(`${props?.caseEnt?.caseNumberValidityFrom}`);
                    startDate.setHours(0, 0, 0, 0);
                    const start = startDate.getTime();
                    const end = new Date(`${props?.caseEnt?.caseNumberValidityTo}`).getTime();

                    if (dateObj.getTime() < start || dateObj.getTime() > end) {
                        return {
                            className: 'rbc-off-range-noEvents',
                        };
                    } else {
                        return {
                            className: 'column',
                        };
                    }
                }}
                onSelectSlot={(propsSel: any) => handleSelect(propsSel)}
                endAccessor="end"
                style={{ height: 1000 }}
            />

            <ModalEvent setParam={(ev) => props.setEvent(ev)} setData={setModalData} data={modalData} />
            <ModalDelete id={deleteModal} setModal={setDeleteModal} setData={setModalData} />
        </div>
    );
};
export default CalendarComponent;
